import { render, staticRenderFns } from "./PageLogic.vue?vue&type=template&id=22965556&scoped=true&"
import script from "./PageLogic.vue?vue&type=script&lang=js&"
export * from "./PageLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22965556",
  null
  
)

export default component.exports